export const sortByKey = (a, b, key, ascOrder = true) => {
  const x = a[key].toLowerCase();
  const y = b[key].toLowerCase();

  let c = 0;

  if (x < y) {
    c = 1;
  } else if (x > y) {
    c = -1;
  }
  return ascOrder ? (c * -1) : c;
};
